module.exports = __webpack_public_path__ + "static/media/pic-ht15.d39a06d6.jpg";